import {TodoModel as Todo} from "./Todo";
import {ContactModel as Contact} from "./Contact";
import {AppointmentModel as Appointment} from "./Appointment";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";

export const TodoModel = Todo;
export const ContactModel = Contact;
export const AppointmentModel = Appointment;

export class DayModel extends Model  {
   key: string;
   items: Collection = new Collection();   

   constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data);
        }
    }
}